"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.preview.errors.noId': 'Nie podano ID płatności',
    'payment.preview.errors.loadFailed': 'Nie udało się załadować szczegółów płatności',
    'payment.preview.refreshed': 'Szczegóły płatności odświeżone',
};
